import React from "react";

export default function MySQL_USER() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_USER</h1>
      <p>This is the MySQL_USER component generated from the SQL JSON.</p>
    </div>
  );
}
